import omit from 'lodash/omit';
import { SUBMISSION_UPDATE_SUBJECT } from '@instructure/quiz-common';
import Fetcher from '../../common/util/Fetcher';
import { postToParent } from '../../common/actions/postMessage';
import { handleQuizSessionResultsResponse } from '../../common/api/callHandlers';
import { getResultInfo } from '../../common/actions/quizSessions';
var removeIdsFromModifications = function removeIdsFromModifications(modifiedResults) {
  return modifiedResults.map(function (result) {
    return omit(result, 'id');
  });
};
export var postQuizSessionResults = function postQuizSessionResults(sessionId, sessionItemResultsModifications, fudgePoints, previousScore) {
  var fetchQuizSessionCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : getResultInfo;
  var quizSessionUrl = "/api/quiz_sessions/".concat(sessionId);
  var url = "".concat(quizSessionUrl, "/results");
  return function (dispatch, getState) {
    var fetchLib = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetch;
    var modifiedResultsWithoutIds = removeIdsFromModifications(sessionItemResultsModifications);
    var params = {
      body: JSON.stringify({
        results: modifiedResultsWithoutIds,
        fudge_points: fudgePoints
      })
    };
    var fetcher = new Fetcher();
    return fetcher.post(url, params).then(function (quizSessionResult) {
      var dispatchActions = [handleQuizSessionResultsResponse([quizSessionResult]), fetchQuizSessionCb(sessionId, null)];
      if (previousScore !== (quizSessionResult === null || quizSessionResult === void 0 ? void 0 : quizSessionResult.score)) {
        dispatchActions.unshift(postToParent({
          subject: SUBMISSION_UPDATE_SUBJECT
        }));
      }
      return dispatch(dispatchActions);
    });
  };
};